import { Warehouse } from './warehouse';
import { TenantGeneralData } from './tenantGeneralData';
import { ContainerActivity } from './containerActivity';

export class Container extends TenantGeneralData {
  name?: string;
  textName?: string;
  description?: string;
  unit?: string;
  warehouse?: Warehouse;
  maxCapacity?: number;
  imgUrl?: string;
  subtractUsageDefault?: boolean;
  type?: string;
  material?: string;
  methodPreservation?: string;
  pavementType?: string;
  activities?: ContainerActivity[];
  quantityWallet?: any;
  productId?: number;
  balance?: number;

  constructor() {
    super();
    this.name = null;
    this.textName = null;
    this.description = null;
    this.unit = null;
    this.warehouse = null;
    this.maxCapacity = null;
    this.imgUrl = null;
    this.subtractUsageDefault = true;
    this.type = null;
    this.material = null;
    this.methodPreservation = null;
    this.pavementType = null;
    this.activities = [];
    this.quantityWallet = null;
    this.productId = null;
    this.balance = null;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User

class Container {
    transient springSecurityService

    Long    companyId = -1
    string name
    string description
    string unit
    string  imgUrl
    Date    dateCreated
    Date    lastUpdated

    static belongsTo    = [warehouse:Warehouse]
    static hasMany      = [activities: ContainerActivity]

    static constraints = {
        name        blank: false, nullable: false
        description blank: false, nullable: true
        unit        blank: false, nullable: true, inList: ['l', 'kg', 'bu']
        imgUrl      blank: false, nullable: true, url: true
    }


    static mapping = {
        autoTimestamp true
    }

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }
}

*/
